import PropTypes from "prop-types";
import { InternalExceptionModal } from "react-common-ui-library/FPACT/InternalExceptionModal";
import { useDispatch, useSelector } from "react-redux";
import { ERROR_CONTACT_INFO } from "../../Constants/CommonConstants";
import { resetError } from "../../Features/ErrorBoundaryStrategySlice";
import { manageErrorBoundarySelector } from "../../Selectors/ErrorBoundarySelector";
import EndpointService from "../../Services/EndpointService";

const errorContactInfo = EndpointService(ERROR_CONTACT_INFO);

/**
 * @description Error fall back component of the account, acts as fall back component when error occurs in the application.
 * @param {function} resetErrorBoundary function to reset error on modal close.
 * @returns {ReactNode} Render the modal with error details and contact information.
 */

function ErrorFallback({ resetErrorBoundary }) {
  const dispatch = useDispatch();
  const { errorCode, errorNumber, showErrorModal } = useSelector((state) =>
    manageErrorBoundarySelector(state)
  );
  const handleClose = () => {
    dispatch(resetError());
    resetErrorBoundary();
  };

  return (
    <>
      {showErrorModal ? (
        <InternalExceptionModal
          phoneNumber={errorContactInfo}
          errorCode={errorCode}
          errorNumber={errorNumber}
          open={showErrorModal}
          handleButtonClick={handleClose}
        />
      ) : null}
    </>
  );
}

ErrorFallback.defaultProps = {
  resetErrorBoundary: () => {},
};

ErrorFallback.propTypes = {
  resetErrorBoundary: PropTypes.func,
};

export default ErrorFallback;
